import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { useNavigate } from "react-router-dom";
import { debounce, isEmpty, startCase } from "lodash";
import BettingHistoryTab from "./BettingHistoryTab";
import CustomCalendar from "./Account/CustomCalendar";
import { formatWithCommas } from "../Utils/Toast";
import { MdArrowRight } from "react-icons/md";
const BettingHistory = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [type, setType] = useState("betting-history");
  const [total, setTotal] = useState(0);
  const [loader, setLoader] = useState(false);
  const [modal, setModal] = useState(false);
  const [filter, setFilter] = useState({
    betType: "betfair",
    status: "completed",
    fromPeriod: moment(new Date()).format("YYYY-MM-DD"),
    toPeriod: moment(new Date()).format("YYYY-MM-DD"),
    page: 1,
    limit: 50,
  });
  let dummy = {
    BetFair: "betfair",
    Bookmaker: "bookmaker",
    Fancy: "fancy",
    SportsBook: "sportBook",
  };
  let betCheckObj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };

  const getData = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.getHistory, {
      betType: obj?.betType,
      status: "completed",
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page || 1,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        if (data?.results?.data?.length > 0) {
          setData(data?.results?.data);
          setTotal(
            obj?.betType == "casino"
              ? calculateTotalsCasino(data?.results?.data)
              : calculateTotals(data?.results?.data),
          );
        } else {
          setData([]);
          setTotal({});
        }
      }
    }
    setLoader(false);
  };
  const getDepositHistory = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.depositHistory, {
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page,
      limit: obj?.limit,
      status: obj?.type,
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
    setLoader(false);
  };
  const getWithdrawHistory = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.withDrawHistory, {
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
    setLoader(false);
  };
  const getAccountHistory = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.accountStatement, {
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
      }
    }
    setLoader(false);
  };
  const ShowPrice = (res) => {
    if (isEmpty(res?.fancyName)) {
      if (
        (res?.teamSelectionWin == res?.selectionId && res?.betType == "back") ||
        (res?.teamSelectionWin != res?.selectionId && res?.betType == "lay")
      ) {
        return res?.profitAmount;
      } else {
        return -res?.loseAmount;
      }
    } else {
      if (res?.type == "No") {
        if (res?.decisionRun < res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      } else {
        if (res?.decisionRun >= res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      }
    }
  };
  function calculateTotalsCasino(bets) {
    let totalAmount = 0;
    let profitLoss = 0;
    let totalOdds = 0;
    bets.forEach((res) => {
      totalAmount += res.betAmount;
      profitLoss += parseFloat(res.playerPL);
    });

    return {
      totalAmount,
      profitLoss,
      totalOdds,
    };
  }
  function calculateTotals(bets) {
    let totalAmount = 0;
    let profitLoss = 0;
    let totalOdds = 0;
    bets.forEach((res) => {
      totalAmount += res.amount;
      totalOdds += parseFloat(res.bhav || 0); // safely parse bhav as float
      let isFancy = !!res.fancyName; // fancyName presence check

      if (!isFancy) {
        const isBackWin =
          res.teamSelectionWin == res.selectionId && res.betType === "back";
        const isLayWin =
          res.teamSelectionWin != res.selectionId && res.betType === "lay";

        if (isBackWin || isLayWin) {
          profitLoss += res.profitAmount;
        } else {
          profitLoss -= res.loseAmount;
        }
      } else {
        // Fancy logic
        const isNo = res.type === "No";

        if (isNo) {
          if (res.decisionRun < res.betRun) {
            profitLoss += res.profitAmount;
          } else {
            profitLoss -= res.loseAmount;
          }
        } else {
          if (res.decisionRun >= res.betRun) {
            profitLoss += res.profitAmount;
          } else {
            profitLoss -= res.loseAmount;
          }
        }
      }
    });

    return {
      totalAmount,
      profitLoss,
      totalOdds,
    };
  }

  const debouncedFetch = useMemo(() => {
    return debounce((obj) => {
      setData([]);

      if (type === "betting-history") {
        getData(obj);
      } else if (type === "deposit-history") {
        getDepositHistory(obj);
      } else if (type === "withdrawl-history") {
        getWithdrawHistory(obj);
      } else if (type === "transaction-history") {
        getAccountHistory(obj);
      }
    }, 500);
  }, [type]);

  useEffect(() => {
    setLoader(true);
    debouncedFetch(filter);

    return () => {
      debouncedFetch.cancel(); // 🔥 important cleanup
    };
  }, [filter, debouncedFetch]);

  return (
    <div className="bank-mid mt-4 col col-10">
      <div className="desktop-flex-column" style={{ height: "100%" }}>
        <div className=" pb-3 histories-type v-card v-sheet theme--light">
          <div className="v-card__title">History</div>

          <div className="row px-10 pb-3 hidden-sm-and-down no-gutters justify-end">
            <div className="col col-12">
              <div className="hl-type-header">
                <button
                  onClick={() => setType("deposit-history")}
                  type="button"
                  className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                    type == "deposit-history" ? "tab-selected no-opacity" : ""
                  }`}
                >
                  <span className="v-btn__content">Deposit History</span>
                </button>
                <button
                  onClick={() => setType("withdrawl-history")}
                  type="button"
                  className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                    type == "withdrawl-history" ? "tab-selected no-opacity" : ""
                  }`}
                >
                  <span className="v-btn__content">Withdrawal History</span>
                </button>
                <button
                  onClick={() => setType("transaction-history")}
                  type="button"
                  className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                    type == "transaction-history"
                      ? "tab-selected no-opacity"
                      : ""
                  }`}
                >
                  <span className="v-btn__content">Account History</span>
                </button>
                <button
                  type="button"
                  onClick={() => setType("betting-history")}
                  className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                    type == "betting-history" ? "tab-selected no-opacity" : ""
                  }`}
                >
                  <span className="v-btn__content">Bet History</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div stlye="padding-top:12px" style={{ height: "100%" }}>
          <div className="row hidden-md-and-up no-gutters">
            <div className="mobile-filter-col col col-5">
              <div className="mobile-menu-card-wrapper-promotion v-card v-sheet theme--light">
                <button
                  type="button"
                  className="mobile-category-menuBtn-promotion v-btn v-btn--block v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="v-btn__content">
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate v-icon--right mdi mdi-menu-down theme--light"
                      style={{ "font-size": "36px" }}
                    />
                  </span>
                </button>
              </div>
              <div className="v-menu">{/**/}</div>
            </div>
            <div className="mobile-filter-col col col-4">
              <div className="mobile-menu-card-wrapper-promotion v-card v-sheet theme--light">
                <button
                  type="button"
                  className="mobile-category-menuBtn-promotion v-btn v-btn--block v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="v-btn__content">
                    DEPOSIT
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate v-icon--right mdi mdi-menu-down theme--light"
                      style={{ "font-size": "36px" }}
                    />
                  </span>
                </button>
              </div>
              <div className="v-menu">{/**/}</div>
            </div>
          </div>
          <div
            style={{ height: "100%" }}
            className="desktop_card_history pt-3 v-card v-sheet theme--light elevation-0"
          >
            <div className="bank-detail-card history-card v-card v-sheet theme--light elevation-0">
              <div className="row no-gutters">
                {type === "betting-history" && (
                  <div className="col col-12" style={{ marginBottom: "10px" }}>
                    <div className="type-header">
                      <button
                        onClick={() =>
                          setFilter((prev) => {
                            return { ...prev, betType: "betfair" };
                          })
                        }
                        type="button"
                        className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                          filter?.betType == "betfair"
                            ? "tab-selected no-opacity"
                            : ""
                        }`}
                      >
                        <span className="v-btn__content">Betfair</span>
                      </button>
                      <button
                        onClick={() =>
                          setFilter((prev) => {
                            return { ...prev, betType: "fancy" };
                          })
                        }
                        type="button"
                        className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                          filter?.betType == "fancy"
                            ? "tab-selected no-opacity"
                            : ""
                        }`}
                      >
                        <span className="v-btn__content">Fancy</span>
                      </button>{" "}
                      <button
                        onClick={() =>
                          setFilter((prev) => {
                            return { ...prev, betType: "bookmaker" };
                          })
                        }
                        type="button"
                        className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                          filter?.betType == "bookmaker"
                            ? "tab-selected no-opacity"
                            : ""
                        }`}
                      >
                        <span className="v-btn__content">Bookmaker</span>
                      </button>
                      <button
                        onClick={() =>
                          setFilter((prev) => {
                            return { ...prev, betType: "sportBook" };
                          })
                        }
                        type="button"
                        className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                          filter?.betType == "sportBook"
                            ? "tab-selected no-opacity"
                            : ""
                        }`}
                      >
                        <span className="v-btn__content">Sportsbook</span>
                      </button>
                      <button
                        onClick={() =>
                          setFilter((prev) => {
                            return { ...prev, betType: "casino" };
                          })
                        }
                        type="button"
                        className={`player-history-tab v-btn v-btn--has-bg theme--light v-size--default ${
                          filter?.betType == "casino"
                            ? "tab-selected no-opacity"
                            : ""
                        }`}
                      >
                        <span className="v-btn__content">Casino</span>
                      </button>
                    </div>
                  </div>
                )}
                <div style={{ height: "100%" }} className="col col-12">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <div className="v-input date-search elevation-0 v-input--hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                      <div
                        className="v-input__control"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          flexWrap: "nowrap",
                        }}
                      >
                        <div
                          style={{ maxWidth: "440px" }}
                          className="v-input__slot"
                        >
                          <fieldset aria-hidden="true">
                            <legend style={{ width: "0px" }}>
                              <span className="notranslate">​</span>
                            </legend>
                          </fieldset>
                          <div
                            onClick={() => setModal(true)}
                            className="v-text-field__slot"
                          >
                            <input
                              style={{ color: "black" }}
                              id="input-774"
                              type="text"
                              readOnly
                              value={`${filter?.fromPeriod} - ${filter?.toPeriod}`}
                            />
                          </div>
                        </div>{" "}
                        <button
                          onClick={() => debouncedFetch(filter)}
                          data-v-1dea3caa
                          type="button"
                          className="full-width font-weight-bold pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default subtitle-1 full-width font-weight-bold white--text pa-2 embedded-register-button mx-3"
                          style={{
                            "background-color": "rgb(0, 128, 246)",
                            "border-radius": "8px",
                            "font-size": "14px !important",
                          }}
                        >
                          <span className="v-btn__content">Search</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="fullHeight mt-6 col col-12">
                  <div className="v-data-table elevation-0 fullHeight theme--light">
                    <div className="v-data-table__wrapper">
                      <table>
                        <thead>
                          {type == "betting-history" && (
                            <tr>
                              <th className="align-L" id="Matched_market">
                                Bet ID
                              </th>
                              <th id="Matched_selection">PL ID</th>
                              <th id="Matched_type" width="3%">
                                Market
                              </th>
                              <th id="Matched_betId" width="9%">
                                Selection
                              </th>
                              <th id="Matched_betPlaced" width="8%">
                                Type
                              </th>
                              <th id="Matched_oddsReq" width="8%">
                                Bet placed
                              </th>
                              <th id="Matched_matched" width="9%">
                                Odds req.
                              </th>
                              <th id="Matched_avgOdds" width="10%">
                                Stake
                              </th>

                              <th id="Matched_dateMatched" width="10%">
                                Profit/Loss
                              </th>
                            </tr>
                          )}
                          {type == "transaction-history" && (
                            <tr>
                              <th scope="col">Date/Time</th>
                              <th scope="col">Deposit</th>
                              <th scope="col">WithDraw</th>
                              <th scope="col">Balance</th>
                              <th scope="col">Remark</th>
                              <th scope="col">From/To</th>
                            </tr>
                          )}
                          {["withdrawl-history", "deposit-history"].includes(
                            type,
                          ) && (
                            <tr>
                              {(type == "withdrawl-history"
                                ? WithdrawHeader
                                : DepositHeader
                              )?.map((res) => {
                                return <th scope="col">{res}</th>;
                              })}
                            </tr>
                          )}
                        </thead>
                        {type == "betting-history" && (
                          <BettingHistoryTab
                            data={data}
                            key={filter?.betType}
                            betCheckObj={betCheckObj}
                          />
                        )}
                        {["withdrawl-history", "deposit-history"].includes(
                          type,
                        ) && ""}
                        {type == "transaction-history" ? (
                          data.data?.length > 0 ? (
                            <tbody id="Matched_Content">
                              {data.data &&
                                data.data.map((item, key) => (
                                  <tr>
                                    <td>
                                      {moment(item?.createdAt).format(
                                        "YYYY-MM-DD hh:mm:ss",
                                      )}
                                    </td>
                                    <td>
                                      {item?.transactionType === "credit" ? (
                                        <span className="">
                                          {formatWithCommas(item?.amount)}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                    <td>
                                      {" "}
                                      {item?.transactionType === "debit" ? (
                                        <span className="text-danger">
                                          {"(" +
                                            formatWithCommas(item?.amount) +
                                            ")"}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </td>

                                    <td>
                                      {formatWithCommas(item?.newBalance)}
                                    </td>
                                    <td width={"26%"}>
                                      {item?.remark || "N/A"}
                                    </td>

                                    <td>
                                      {startCase(
                                        item?.createdByData?.userType,
                                      ) || "N/A"}{" "}
                                      <MdArrowRight
                                        size={20}
                                        style={{ verticalAlign: "middle" }}
                                      />
                                      {item?.userData?.username || "N/A"}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          ) : (
                            <tbody id="Matched_Content">
                              <tr
                                id="noDataTemplate"
                                style={{
                                  display: "table-row",
                                }}
                              >
                                <td className="no-data" colSpan="9">
                                  <p>You have no bets in this time period.</p>
                                </td>
                              </tr>
                            </tbody>
                          )
                        ) : (
                          ""
                        )}
                        {["withdrawl-history", "deposit-history"].includes(
                          type,
                        ) && (
                          <tbody>
                            {" "}
                            {data?.length > 0 ? (
                              data?.map((res) => {
                                return type == "deposit-history" ? (
                                  <tr className="table-tr">
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {startCase(res?.bank_name) ||
                                        startCase(res.bank)}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {moment(res?.createdAt).format(
                                        "YYYY-MM-DD hh:mm:ss",
                                      )}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {formatWithCommas(res?.amount)}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {formatWithCommas(
                                        res?.amount +
                                          (res?.bonus > 0 ? res?.bonus : 0),
                                      )}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {res?.transferedProcess == "process"
                                        ? "Processing"
                                        : res?.status == "completed"
                                          ? "Approve"
                                          : res?.transferedProcess ==
                                              "requested"
                                            ? "Requested"
                                            : "Decline"}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {res?.promotionCode || "-"}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {res?.remark || "-"}
                                    </td>{" "}
                                  </tr>
                                ) : type == "withdrawl-history" ? (
                                  <tr className="table-tr">
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {startCase(res?.bank_name) ||
                                        startCase(res.bank)}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {moment(res?.createdAt).format(
                                        "YYYY-MM-DD hh:mm:ss",
                                      )}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {formatWithCommas(res?.amount)}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {formatWithCommas(
                                        res?.amount +
                                          (res?.bonus > 0 ? res?.bonus : 0),
                                      )}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {res?.transferedProcess == "process"
                                        ? "Processing"
                                        : res?.status == "completed"
                                          ? "Approve"
                                          : res?.transferedProcess ==
                                              "requested"
                                            ? "Requested"
                                            : "Decline"}
                                    </td>{" "}
                                    <td
                                      style={{ width: "13%" }}
                                      className="table-td"
                                    >
                                      {res?.remark || "-"}
                                    </td>{" "}
                                  </tr>
                                ) : (
                                  ""
                                );
                              })
                            ) : (
                              <tr
                                id="noDataTemplate"
                                style={{
                                  display: "table-row",
                                }}
                              >
                                <td className="no-data" colSpan="9">
                                  <p>You have no bets in this time period.</p>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal && (
        <CustomCalendar
          setShow={setModal}
          value={filter}
          onChange={(e) => {
            setFilter((prev) => {
              return {
                ...prev,
                fromPeriod: moment(e?.startDate).format("YYYY-MM-DD"),
                toPeriod: moment(e?.endDate).format("YYYY-MM-DD"),
              };
            });
          }}
        />
      )}
    </div>
  );
};

let WithdrawHeader = [
  "Bank",
  "Transaction Time",
  "Requested amount",
  "Received amount",
  "Status",
  "Remark",
];
let DepositHeader = [
  "Bank",
  "Transaction Time",
  "Requested amount",
  "Received amount",
  "Status",
  "Promotions",
  "Remark",
];
export default BettingHistory;
